export default "__VITE_ASSET__4f8d78a7__"